'use client';

import React from 'react';
import { Button } from 'ui';
import { isEnvDev } from 'utils';

const dashboardOrigin = isEnvDev
  ? 'http://app.localhost:3000'
  : 'https://app.quotion.co';

export function SignInButton() {
  return (
    <Button className="w-full sm:w-fit" onClick={signInToDashboard}>
      Login
    </Button>
  );
}

export function signInToDashboard() {
  window.location.href = `${dashboardOrigin}/auth/login${getAffosoSearch()}`;
}

function getAffosoSearch() {
  const atp = localStorage.getItem('affonso_atp');
  const affonso = localStorage.getItem('affonso_affonso');
  const aff = localStorage.getItem('affonso_aff');
  const via = localStorage.getItem('affonso_via');
  const ref = localStorage.getItem('affonso_ref');
  if (atp) {
    return `?atp=${atp}`;
  }
  if (affonso) {
    return `?affonso=${affonso}`;
  }
  if (aff) {
    return `?aff=${aff}`;
  }
  if (via) {
    return `?via=${via}`;
  }
  if (ref) {
    return `?ref=${ref}`;
  }
  return '';
}
